import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function PatMenu() {
    const pat_id = localStorage.getItem('pat_id');
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    )
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">Patient</h5>

            <div className="row">

                <MenuCard link={`/pat-bill-details/${pat_id}`} title="Billing Details" icon="fa-solid fa-file-invoice"
                          color="#0d6efd"/>

                <MenuCard link={`/pat-emr-details/${pat_id}`} title="EMR Details" icon="fa-solid fa-notes-medical"
                          color="#20c997"/>

                <MenuCard link={`/pat-lab-details/${pat_id}`} title="Lab Results" icon="fa-solid fa-vial"
                          color="#6f42c1"/>

                <MenuCard link={`/pat-vital-details/${pat_id}`} title="Vital Results" icon="fa-solid fa-heart-pulse"
                          color="#dc3545"/>

                <MenuCard link={`/pat-drug-details/${pat_id}`} title="Drug Prescription" icon="fa-solid fa-pills"
                          color="#fd7e14"/>

                <MenuCard
                    link="/telemedicine-appointments"
                    title="Telemedicine"
                    icon="fa-solid fa-video"
                    color="#198754"
                />
            </div>

        </section>
    )
}
export default PatMenu;